import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../services/authentication.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { TimersService } from "../../services/timers.service";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { provideAnimations } from '@angular/platform-browser/animations';

@Component({
  selector: 'app-login',
  imports: [CommonModule, NgxSpinnerModule],
  templateUrl: './login.html',
  styleUrl: './login.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', overflow: 'hidden' })),
      state('expanded', style({ height: '*', overflow: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
    ]),
    trigger('expandCollapse', [
      transition(':enter', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: '0px', opacity: 0 })),
      ]),
    ]),
  ],
})

export class Login implements OnInit {
  isMobileView: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private timersService: TimersService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }


  ngOnInit() {
    this.checkIfMobile();
    window.addEventListener('resize', () => this.checkIfMobile());
    if (this.authenticationService.isTokenNoValid()) {
      localStorage.clear();
      return;
    }
    this.spinner.show();
    this.authenticationService.setUser().then(() => {
      this.spinner.hide();
      this.timersService.startTimerToken();
      this.router.navigate(['/potenciales-proyectos/listar']);
    }).catch(() => {
      this.spinner.hide();
    });
  }


  checkIfMobile(): void {
    const mobileWidth = 571; // Ancho máximo para considerar móvil
    this.isMobileView = window.innerWidth <= mobileWidth;
  }

  login() {
    try {
      this.spinner.show();
      const url = this.authenticationService.login();
      window.location.href = url;
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }

  }


}
